import { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import "./home.css";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import ASSETS from "../../../app/config/assets";
import { useNavigate } from "react-router-dom";
import { FaRegLightbulb } from "react-icons/fa6";
import { HiOutlineHandThumbUp } from "react-icons/hi2";
import { TbTargetArrow } from "react-icons/tb";
//
import Inclusion from "../components/inclusion/Inclusion";
import Features from "../components/features/Features";
import AfricaConnect from "../components/africa-connect/AfricaConnect";
import Approaches from "../components/approach/Approaches";
import HowItWorks from "../components/how-it-works/HowItWorks";
import AppDownload from "../components/app-download/AppDownload";
//

const Home = () => {
  const navigate = useNavigate();
  const [fix, setFix] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setFix(window.scrollY >= 1000);
    };

    window.addEventListener("scroll", handleScroll);

    // Met à jour l'état au montage
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const bannerContainerRef = useRef(null);
  const forWhoContainerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline();

      const img = bannerContainerRef.current.querySelector("img");
      const h1 = bannerContainerRef.current.querySelector("h1");
      const p = bannerContainerRef.current.querySelector("p");
      const btn = bannerContainerRef.current.querySelector("button");

      // Initial state
      gsap.set(img, { x: 100, opacity: 0 }); // from right
      gsap.set(h1, { x: -100, opacity: 0 }); // from left
      gsap.set(p, { y: 50, opacity: 0 }); // from bottom
      gsap.set(btn, { y: 50, opacity: 0 }); // from bottom

      // Timeline animation
      tl.to(img, { x: 0, opacity: 1, duration: 0.8 }) // 1st: img
        .to(h1, { x: 0, opacity: 1, duration: 0.8 }, "+=0.002") // 2nd: h1 after 2ms
        .to(p, { y: 0, opacity: 1, duration: 0.8 }, "+=0.003") // 3rd: p after 3ms
        .to(btn, { y: 0, opacity: 1, duration: 0.8 }, "+=0.001"); // 4th: button after 1ms
    }, bannerContainerRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const texts = gsap.utils.toArray(".h-t-io-row");
      const images = gsap.utils.toArray(".h-target-item-inner img");

      // Etat initial
      gsap.set(images, {
        autoAlpha: 0,
        scale: 1.12,
        position: "absolute",
        inset: 0,
        transformOrigin: "center center",
      });

      gsap.set(texts, {
        autoAlpha: 0,
        y: 50,
        position: "absolute",
        inset: 0,
      });

      const tl = gsap.timeline({
        repeat: -1,
        defaults: {
          ease: "power3.out",
        },
      });

      texts.forEach((text, i) => {
        const image = images[i];

        tl

          // =========================
          // 1. Apparition de l'image
          // =========================
          .to(image, {
            autoAlpha: 1,
            scale: 1,
            duration: 1.2,
          })

          // =========================
          // 2. Le texte arrive 300 ms plus tard
          // =========================
          .to(
            text,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
            },
            "+=0.3",
          )

          // =========================
          // 3. Léger zoom continu pendant la lecture
          // =========================
          .to(
            image,
            {
              scale: 1.05,
              duration: 2.5,
              ease: "none",
            },
            "<",
          )

          // =========================
          // 4. Temps de lecture
          // =========================
          .to({}, { duration: 1.8 })

          // =========================
          // 5. Disparition du texte
          // =========================
          .to(text, {
            autoAlpha: 0,
            y: -30,
            duration: 0.6,
            ease: "power2.in",
          })

          // =========================
          // 6. Disparition de l'image
          // =========================
          .to(
            image,
            {
              autoAlpha: 0,
              scale: 1.08,
              duration: 0.8,
              ease: "power2.inOut",
            },
            "<",
          );
      });
    }, forWhoContainerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="w-screen position-relative bg-primary home">
      <Header fix={fix} />
      <div className="h-banner">
        <div className="h-banner-outer" ref={bannerContainerRef}>
          <div className="h-banner-outer-text">
            <h1>🏫 The school that reaches every learner, wherever you are.</h1>
            <p>
              An inclusive digital school delivering high-quality, interactive
              learning to every student in rural, urban, and peri-urban
              communities—with or without an Internet connection.
            </p>
            <button
              className="banner-outer-button"
              onClick={() => navigate("/signup", { replace: true })}
            >
              <FaRegLightbulb className="banner-button-icon" />

              <span className="banner-button-text">
                Register now and start learning...
              </span>
            </button>
          </div>
          <img src={ASSETS?.masomo_banner2} alt="Classroom illustration" />
        </div>
      </div>
      {/* Features */}
      <Features />
      {/* Inclusion */}
      <Inclusion />
      {/* AfricaConnect */}
      <AfricaConnect />
      {/* Approaches */}
      <Approaches />
      {/* HowItWorks */}
      <HowItWorks />
      {/* AppDownload */}
      <AppDownload />
      {/* footer */}
      <Footer />
    </div>
  );
};

export default Home;
